import React from "react";
import { motion } from "framer-motion";

// Reusable section wrapper with top "overline" kicker and a large heading.
export function SectionHeader({ kicker, title, subtitle, align = "left" }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {kicker && <div className="overline mb-5">{kicker}</div>}
      <h2 className="font-display text-4xl sm:text-5xl lg:text-[56px] leading-[1.02] tracking-[-0.02em] text-white">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-white/60 text-lg leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 18, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.8,
        delay,
        ease: [0.2, 0.7, 0.2, 1],
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default function Section({
  id,
  children,
  className = "",
  padded = true,
  ...rest
}) {
  return (
    <section
      id={id}
      className={`relative ${padded ? "py-24 lg:py-36" : ""} ${className}`}
      {...rest}
    >
      <div className="container-edge">{children}</div>
    </section>
  );
}
